import { Report } from '@/api/generatedApi';

const UNKNOWN_REPORT_CREATOR = 'Unknown user';

export const getReportCreatorLabel = (report: Pick<Report, 'creator'>): string =>
  report.creator?.email ?? UNKNOWN_REPORT_CREATOR;
